export abstract class ArrayHelper {

    public static uniqueFilter(value, index, self) {
        return self.indexOf(value) === index;
    }

    //sort the array by string field with localCompare
    public static sortByStringField(array: any[], field: string): any[] {
        return array.sort((a, b) => a[field].localeCompare(b[field]));
    }
    
    //sort the array by a number field descending
    public static sortByNumberFieldDesc(array: any[], field: string): any[] {
        return array.sort((a, b) => b[field] - a[field]);
    }
}